import { type DrawerPanel } from '@canvas/model/sidebar-panel';
import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

export interface UpdatePanelStateCommandProperties extends CommandProperties {
  panel: DrawerPanel | 'none';
  width: number;
}

export const UpdatePanelStateCommand =
  createCommand<UpdatePanelStateCommandProperties>('update-panel-state');
